'use client';

import React, { useState } from 'react';
import SonarrPanel from './SonarrPanel';
import RadarrPanel from './RadarrPanel';
import WebhookPanel from './WebhookPanel';
import CustomItemsPanel from './CustomItemsPanel';
import { Settings, Tv2, Clapperboard, Webhook, Package } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const sections = [
  { key: 'sonarr', label: 'Sonarr', icon: Tv2 },
  { key: 'radarr', label: 'Radarr', icon: Clapperboard },
  { key: 'webhooks', label: 'Webhooks', icon: Webhook },
  { key: 'custom', label: 'Custom Items', icon: Package },
];

type SectionKey = 'sonarr' | 'radarr' | 'webhooks' | 'custom';

export default function SettingsScreen() {
  const [activeSection, setActiveSection] = useState<SectionKey>('sonarr');

  return (
    <div className="min-h-full">
      {/* Header */}
      <div
        className="sticky top-0 z-20 border-b border-border px-6 xl:px-8 2xl:px-10 py-4"
        style={{ background: 'var(--background)' }}
      >
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-muted flex items-center justify-center">
            <Settings size={16} className="text-muted-foreground" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-foreground">Settings</h1>
            <p className="text-xs text-muted-foreground mt-0.5">
              Configure API connections, webhook endpoints, and custom items
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex px-6 xl:px-8 2xl:px-10 py-6 gap-6 max-w-screen-2xl">
        {/* Left nav */}
        <div className="w-44 flex-shrink-0">
          <nav className="flex flex-col gap-1 sticky top-[89px]">
            {sections.map((s) => {
              const Icon = s.icon;
              const isActive = activeSection === s.key;
              return (
                <button
                  key={`settings-nav-${s.key}`}
                  onClick={() => setActiveSection(s.key as SectionKey)}
                  className={`flex items-center gap-2.5 px-3 py-2 text-sm font-medium rounded-lg text-left transition-all duration-150 ${
                    isActive ? 'sidebar-item-active' : 'sidebar-item'
                  }`}
                >
                  <Icon size={15} />
                  {s.label}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Panel content */}
        <div className="flex-1 min-w-0">
          {activeSection === 'sonarr' && <SonarrPanel />}
          {activeSection === 'radarr' && <RadarrPanel />}
          {activeSection === 'webhooks' && <WebhookPanel />}
          {activeSection === 'custom' && <CustomItemsPanel />}
        </div>
      </div>
    </div>
  );
}